import { useState } from "react";
import Dialog from "../../../components/Dialog";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialgoStyles from "../../../styles/components/DialogStyles";
import { StyledInfoLabel } from "../../../styles/pages/Schedule/ModalViewDetailsStyles";
import InputLabelTextArea from "../../../components/InputLabelTextArea";

const { BtnPrimary } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton } = DialgoStyles;

interface ModalProps {
    open: boolean;
    onClose?: (callback?: any) => void;
    onSubimit?: (callback?: any) => void;
}

function ModalJustificativa(props: ModalProps) {
    const { open, onClose, onSubimit } = props;
    const [justificativa, setJustificativa] = useState("");
    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            size="width-700 modal-white modal-radius-8"
        >
            <StyledModalTitle className="mb-3">
                Sua justificativa
            </StyledModalTitle>
            <div style={{ height: 20 }} />
            <StyledInfoLabel>Justificativa</StyledInfoLabel>
            <InputLabelTextArea
                value={justificativa}
                placeholder="Insira sua justificativa"
                onChange={(event: any) =>
                    setJustificativa(event.target.value as string)
                }
                viewLengthInfo
                maxLength={500}
                style={{
                    height: "107px",
                    borderStyle: "solid",
                    borderColor: "#787878",
                }}
            />
            <StyledContainerButton className="mt-3">
                <BtnPrimary
                    disabled={justificativa.length === 0}
                    onClick={onSubimit}
                >
                    Enviar
                </BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );
}

export default ModalJustificativa;
